<template>
  <WidgetCard title="Alert volume" icon="area-chart" :loading="loading" :error="error">
    <template #headerExtra>
      <a-radio-group :value="chartType" @change="onChangeType">
        <a-radio-button value="bar">
          <a-icon type="bar-chart" />
        </a-radio-button>
        <a-radio-button value="line">
          <a-icon type="line-chart" />
        </a-radio-button>
      </a-radio-group>
    </template>
    <template #toolbar>
      <div class="dw-trend-toolbar">
        <span class="dw-sevtoggles__label">Total alerts per day</span>
        <a-radio-group :value="days" @change="onChangeWindow">
          <a-radio-button :value="3">
            3D
          </a-radio-button>
          <a-radio-button :value="7">
            7D
          </a-radio-button>
          <a-radio-button :value="14">
            14D
          </a-radio-button>
          <a-radio-button :value="30">
            30D
          </a-radio-button>
          <a-radio-button :value="90">
            90D
          </a-radio-button>
        </a-radio-group>
      </div>
    </template>
    <div class="dw-chart">
      <BarChart v-if="chartType === 'bar'" :chartData="chartData" :options="chartOptions" :styles="fillStyles" />
      <LineChart v-else :chartData="chartData" :options="chartOptions" :styles="fillStyles" />
    </div>
  </WidgetCard>
</template>

<script>
  import moment from 'moment';
  import WidgetCard from './WidgetCard.vue';
  import BarChart from '@shared/components/BarChart';
  import LineChart from '@shared/components/LineChart';
  import DashboardService from '../../services/dashboard.service';
  import dashboardWidget from '../../mixins/dashboardWidget.mixin';
  import dashboardFilters from '../../mixins/dashboardFilters.mixin';

  const SERIES_COLOR = '#20a4b8';

  export default {
    name: 'AlertsTotalTrendWidget',
    components: { WidgetCard, BarChart, LineChart },
    mixins: [dashboardWidget, dashboardFilters],
    data() {
      return {
        days: 7,
        chartType: 'bar',
        series: [],
        fillStyles: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }
      };
    },
    computed: {
      chartData() {
        const labels = this.series.map((d) => moment(d.date).format('D MMM'));
        const data = this.series.map((d) => d.count);
        const isLine = this.chartType === 'line';
        const dataset = isLine
          ? {
            label: 'Alerts',
            data,
            borderColor: SERIES_COLOR,
            backgroundColor: SERIES_COLOR,
            pointBackgroundColor: SERIES_COLOR,
            borderWidth: 2,
            pointRadius: 2,
            pointHoverRadius: 4,
            fill: false,
            lineTension: 0
          }
          : { label: 'Alerts', data, backgroundColor: SERIES_COLOR };
        return { labels, datasets: [dataset] };
      },
      chartOptions() {
        return {
          title: { display: false },
          legend: { display: false },
          scales: {
            xAxes: [{ gridLines: { display: false }, categoryPercentage: 0.65, barPercentage: 0.9 }],
            yAxes: [{ ticks: { beginAtZero: true, precision: 0 }, gridLines: { color: '#eef0f2' } }]
          },
          tooltips: { mode: 'index', intersect: false },
          responsive: true,
          maintainAspectRatio: false
        };
      }
    },
    methods: {
      cacheDescriptors() {
        return [DashboardService.resources.totalTrend(this.days, this.tagIds, this.planTypes)];
      },
      onChangeWindow(e) {
        this.days = e.target.value;
        this.fetchData();
      },
      onChangeType(e) {
        this.chartType = e.target.value;
      },
      fetchResource() {
        return DashboardService.fetchTotalTrend(this.days, this.tagIds, this.planTypes);
      },
      applyResult(res) {
        this.series = res.series;
      }
    }
  };
</script>
